export default "__VITE_ASSET__Dht1wROn__"